import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/botao.css';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';

class PresidenteSessao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            opcoesPresidentes: computed,
            sessoes: computed,
            sessoesSessaoSelecionada: computed,
            sessoesProcessos: computed
        });
    }

    get opcoesPresidentes() {
        return this.converterOpcoes(this.sessaoStore.sessaoSelecionada.composicaoPadrao);
    }

    converterOpcoes = (magistrados) => {
        return magistrados.map((magistrado) => {
            return {
                valor: magistrado.titular,
                texto: magistrado.titular.sigla + ' - ' + magistrado.titular.nome,
                textoSecundario: magistrado.titular.nome
            };
        });
    };

    get sessoes() {
        return this.sessoesProcessos || this.sessoesSessaoSelecionada;
    }

    get sessoesSessaoSelecionada() {
        return (this.sessaoStore.sessaoSelecionada && this.sessaoStore.sessaoSelecionada.sessoes) || [];
    }

    get sessoesProcessos() {
        let processosPorSessao = this.observableProps.processosPorSessao;
        if (processosPorSessao) {
            let retorno = [];
            for (let sessaoId in processosPorSessao) {
                retorno.push(this.sessoesSessaoSelecionada.find((sessao) => sessao.id === sessaoId));
            }
            return retorno;
        }
        return undefined;
    }

    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px', alignItems: 'center' }}>
                {this.sessoes.map((sessao) => (
                    <div
                        key={'presidente' + sessao.id}
                        style={{ display: 'flex', width: '500px', margin: '4px 10px' }}
                    >
                        <AutoComplete
                            apresentarTextoSecundario
                            value={
                                sessao.presidente && sessao.presidente.sigla !== 0
                                    ? sessao.presidente.sigla + ' - ' + sessao.presidente.nome
                                    : null
                            }
                            options={this.opcoesPresidentes}
                            onChange={(option) => this.observableProps.callbackAutoComplete(option, sessao.id)}
                            label={'Presidente da sessão ' + sessao.descricao}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

export default inject('stores')(observer(PresidenteSessao));
